module.exports = __webpack_public_path__ + "static/media/poor.89bd9d59.png";